module.exports = __webpack_public_path__ + "static/flybit_profile@3x-a5b475f0a97e159af11225f45a14c05c.png";